import { Box, Button, Stack, Text, usePopper } from "@chakra-ui/react";
import { useEffect } from "react";

interface OnboardingModalProps {
  onCancel: () => void;
  onToggleOnboarding: (shouldShow: boolean) => void;
}

const confirmCancelTitle = "Access your onboarding later";
const confirmCancelDescription = "You can always restart your onboarding and track your progress here.";

export const OnboardingConfirmCancel = (props: OnboardingModalProps) => {
  const { popperRef, referenceRef } = usePopper({ placement: "top-start", offset: [6, 0] });
  const { onCancel, onToggleOnboarding } = props;

  useEffect(() => {
    const externalElement = document.querySelector(".help_button") as HTMLDivElement | null;
    referenceRef(externalElement);
  }, [referenceRef]);

  return (
    <>
      <Box className="pulse" position="absolute" ref={popperRef} borderRadius={"10px"} width="12px" height="12px" />
      <Stack
        borderRadius={"0.5rem"}
        color="foreground.inverse"
        position="absolute"
        bottom="1rem"
        right="4rem"
        background="foreground.primary"
        padding="1.5rem"
        gap="0"
        maxWidth={"23rem"}
      >
        <Text color="foreground.inverse" textStyle="label/L/medium">
          {confirmCancelTitle}
        </Text>
        <Text mt={"1.5rem"} mb={"2rem"} textStyle="body/M">
          {confirmCancelDescription}
        </Text>
        <Stack direction="row" alignSelf="flex-end">
          <Button
            onClick={onCancel}
            color="foreground.inverse"
            variant="ghost"
            border="1px solid"
            borderColor="transparent"
            _hover={{
              background: "foreground.primary",
              color: "foreground.inverse",
              border: "1px solid",
              borderColor: "foreground.inverse",
            }}
          >
            Resume Onboarding
          </Button>
          <Button variant="primary" onClick={() => onToggleOnboarding(false)}>
            Got it
          </Button>
        </Stack>
      </Stack>
    </>
  );
};
